var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeftSlim(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24,5.5a.5.5,0,0,1-.5.5H1.71l4.14,4.15a.48.48,0,0,1,0,.7.48.48,0,0,1-.7,0l-5-5A.36.36,0,0,1,0,5.69a.5.5,0,0,1,0-.38.36.36,0,0,1,.11-.16l5-5a.48.48,0,0,1,.7,0,.48.48,0,0,1,0,.7L1.71,5H23.5A.5.5,0,0,1,24,5.5Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftSlim);
export default __webpack_public_path__ + "static/media/arrow-left-slim.297222f2d264082ec654edc207ce455c.svg";
export { ForwardRef as ReactComponent };